import React, {useState, createRef, forwardRef, useImperativeHandle} from "react";
import { useQueryClient } from 'react-query';
import __ from "lodash";

import useCompanyContacts from "../../../services/companies/useCompanyContacts";

const getContact = (contactMethods) => {
  const foundMethods = {};
  if (contactMethods && Array.isArray(contactMethods)) {
    for (let method = 0; method < contactMethods.length; method++) {
      const contactMethod = contactMethods[method];
      if (__.has(contactMethod, "phone")) {
        if ( !__.has(foundMethods, "phone")) {
          foundMethods["phone"] = contactMethod["phone"];
          continue;
        }
        if (!__.has(foundMethods, "altPhone")) {
          foundMethods["altPhone"] = contactMethod["phone"];
          continue;
        }
      }
      if (__.has(contactMethod, "email")) {
        if ( !__.has(foundMethods, "email")) {
          foundMethods["email"] = contactMethod["email"];
          continue;
        }
      }
    }
  }
  return foundMethods;
}

const CompanyContacts = forwardRef((props, ref) => {
  const firstName = props.firstName;
  const lastName = props.lastName;
  const email = props.email;

  useImperativeHandle(ref, () => ({

    getContactDetails () {

      if (contacts.data) {
        const rows = contacts.data;
        if (rows && rows.length > 0) {
          const companyContact = {
            ...rows[0],
            ...getContact(rows[0].contactMethods)
          }
          return companyContact;
        }
      }
      return {}
    }

  }));


  const queryClient = useQueryClient();
  const tableRef = createRef({state: {lastEditingRow: false}});
  let extraKeys = props.gsa ? [props.companyUuid, "BOOKING AGENT"] : [props.companyUuid];
  //pass a dummy key so hits to cache will return dummy record until rendering tooltip
  const contacts = useCompanyContacts({ queryClient, extraKeys: extraKeys});

  if (contacts.data && Array.isArray(contacts.data) && contacts.data.length > 0) {
    if (props.onChange) {
      const contact = __.find(contacts.data, {forename: firstName, surname: lastName});
      if (contact) {
        const contactMethods = contact.contactMethods;
        if (__.find(contactMethods, {email: email})) {
          const companyContact = {
            ...contact,
            ...getContact(contactMethods)
          };
          props.onChange(companyContact);
        }
      } else {
        const companyContact = {
          ...contacts.data[0],
          ...getContact(contacts.data[0].contactMethods)
        };
        props.onChange(companyContact);
      }
    }
  }

  return ( <></> );
})

export default CompanyContacts;
